import Event from '../../core/Event';

export default class UserLogoutRequested extends Event {
    public static type = 'UserLogoutRequested';

    constructor() {
        super(UserLogoutRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserLogoutRequested.ts